import React from 'react';
import PropTypes from 'prop-types';
import LegacyLink from '../../Common/LegacyLink';
import Zendesk from '../../Common/ZendeskLink';
import EnabledFeature from '../../Decorators/enabledFeature';
import { track } from '../../../helpers/Tracking/Analytics';

const SecondaryNav = ({ secondaryClass, isAdmin, user, isStatic }) => (
  <ul className={`${secondaryClass} c-header__menu--secondary`}>
    {isAdmin && [
      <li key="su">
        <LegacyLink to="admin/su/">SU</LegacyLink>
      </li>,
      <li key="admin">
        <LegacyLink to="admin/">Admin</LegacyLink>
      </li>
    ]}
    {user && [
      <li key="bookings">
        <LegacyLink to="dashboard/bookings/">Bookings</LegacyLink>
      </li>,
      <li key="messages">
        <LegacyLink to="dashboard/messaging/">
          Messages
          {user.unreadMessages > 0 && <div>{user.unreadMessages}</div>}
        </LegacyLink>
      </li>,
      <li key="howitworks" className="desktop-hidden">
        <LegacyLink to="about/how-it-works/">How it works</LegacyLink>
      </li>,
      <li key="help" className="desktop-hidden">
        <Zendesk isStatic={isStatic}>Help</Zendesk>
      </li>,
      <li key="downloadapp" className="desktop-hidden">
        <a href="https://justpark.onelink.me/3963458492?c=website-homepage&af_dp=justpark://download-app">
          Download our app
        </a>
      </li>,
      <li key="rentoutdriveway" className="desktop-hidden">
        <LegacyLink to="rent-out-a-parking-space/">
          Rent out your driveway
        </LegacyLink>
      </li>,
      <li key="managespaces" className="mobile-hidden">
        <LegacyLink to="dashboard/parking-spaces">Manage my spaces</LegacyLink>
      </li>,
      <li key="billing" className="mobile-hidden">
        <LegacyLink to="dashboard/billing">Billing</LegacyLink>
      </li>,
      <li key="invitefriends" className="mobile-hidden">
        <LegacyLink to="refer-a-friend">Invite friends</LegacyLink>
      </li>,
      <EnabledFeature name="primary_header_invest_link">
        <li className="desktop-hidden">
          <LegacyLink
            to="about/justpark-is-crowdfunding-2019/"
            onClick={() => track('click:web-nav:invest-in-justpark')}
          >
            JustPark is Crowdfunding
          </LegacyLink>
        </li>
      </EnabledFeature>,
      <li key="logout">
        <LegacyLink to="auth/logout">Log out</LegacyLink>
      </li>
    ]}
    {!user && [
      <li key="howitworks" className="desktop-hidden">
        <LegacyLink to="about/how-it-works">How it works</LegacyLink>
      </li>,
      <li key="help" className="desktop-hidden">
        <Zendesk isStatic={isStatic}>Help</Zendesk>
      </li>,
      <li key="download" className="desktop-hidden">
        <LegacyLink to="redirect/app-download">Download our app</LegacyLink>
      </li>,
      <li key="rentspace" className="desktop-hidden">
        <LegacyLink to="rent-out-a-parking-space/">
          Rent out your driveway
        </LegacyLink>
      </li>,
      <EnabledFeature name="primary_header_invest_link">
        <li className="desktop-hidden">
          <LegacyLink
            to="about/justpark-is-crowdfunding-2019/"
            onClick={() => track('click:web-nav:invest-in-justpark')}
          >
            JustPark is Crowdfunding
          </LegacyLink>
        </li>
      </EnabledFeature>
    ]}
  </ul>
);

export default SecondaryNav;

SecondaryNav.defaultProps = {
  user: false,
  isStatic: false
};

SecondaryNav.propTypes = {
  secondaryClass: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  isStatic: PropTypes.bool
};
